export default {
    List: `/api/profile/addresses/list`,
    Create: `/api/profile/addresses`,
    CalculateDeliveryPrice: `/api/factors/calculateDeliveryPrice`,
    Update: (id: number) =>  `/api/profile/addresses/${id}`,
    Delete: (id: number) =>  `/api/profile/addresses/${id}`,
}